import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IFloorMapSpace } from '../types'
import { FloorMapSpaceFragment, SpaceAssignmentFragment } from '../fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  createUnallocationMoveOrders: {
    moveOrders: Array<{
      id: string
      space: IFloorMapSpace
    }>
  }
}

const mutateHandler = handleFetchResult<IPayload, Array<IFloorMapSpace>>({
  handler: (data) => data.createUnallocationMoveOrders.moveOrders.map((mo) => mo?.space),
  name: 'Assignment Plan',
})

export default function unAllocate(
  assignmentPlanId: string,
  input: {
    assignmentPlanId: string
    spaceIds: string[]
  }
): Promise<IFloorMapSpace[]> {
  return client.gql.mutate({ mutation, variables: { assignmentPlanId, input } }).then(mutateHandler)
}

const mutation = gql`
  mutation createUnallocationMoveOrders(
    $input: CreateUnallocationMoveOrdersInput!
    $assignmentPlanId: ID
  ) {
    createUnallocationMoveOrders(input: $input) {
      moveOrders {
        id
        space {
          ...FloorMapSpaceFragment
          spaceAssignment(assignmentPlanId: $assignmentPlanId) {
            ...SpaceAssignmentFragment
          }
        }
      }
    }
  }
  ${FloorMapSpaceFragment}
  ${SpaceAssignmentFragment}
`
